import Utils from 'common/utils'

class LocationStringManager {
    getLocationString(area, city, defaultLocStr) {
        var locStr = null;
        if (Utils.isEmptyStr(city) && Utils.isEmptyStr(area)) {
            // Both are not available
            locStr = "";
        } else if (Utils.isEmptyStr(city) || Utils.isEmptyStr(area)) {
            // Either is available
            locStr = city;
            if (Utils.isEmptyStr(locStr)) {
                locStr = area
            }
        } else {
            // Both are available
            locStr = area + ', ' + city
        }

        if (Utils.isEmptyStr(locStr) && false === Utils.isEmptyStr(defaultLocStr)) {
        locStr = defaultLocStr;
        }
        return locStr
    }
}

let instance = new LocationStringManager()
export default instance


// WEBPACK FOOTER //
// ./src/manager/locationStringManager.js